import BaseRepository from './BaseRepository';

export default class ActionsRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'actions';
    }

    sendAccountSetup(data)
    {
        return this.request('POST', `v1/${this.getEndpoint()}/send-account-setup`, data);
    }

    requestRegistration(data)
    {
        return this.request('POST', `v1/${this.getEndpoint()}/request-registration`, data);
    }

    requestB2CRegistration(data)
    {
        return this.request('POST', `v1/${this.getEndpoint()}/request-registration-b2c`, data);
    }
}
